import tm from './client';
const opts = {
    headers: {
        Accept: 'application/vnd.sncr.tagmanager-1.0+json',
        'Content-Type': 'application/vnd.sncr.tagmanager-1.0+json',
    },
};
const apiType = 'tm';
export const getTagManager = async (endpoint, headers, logger) => {
    logger ? tm.setLogger(logger) : undefined;
    return tm.get(`/user/{userId}/${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
export const putTagManager = async (endpoint, headers, logger) => {
    logger ? tm.setLogger(logger) : undefined;
    return tm.put(`/user/{userId}/${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
export const postTagManager = (body, endpoint, headers, logger) => {
    logger ? tm.setLogger(logger) : undefined;
    return tm.post(`/user/{userId}/${endpoint}`, apiType, {
        data: body,
        headers: { ...opts.headers, ...headers },
    });
};
export const deleteTagManager = async (endpoint, headers, logger) => {
    logger ? tm.setLogger(logger) : undefined;
    return tm.delete(`/user/{userId}/${endpoint}`, apiType, {
        headers: { ...opts.headers, ...headers },
    });
};
